export const initialInputState = {
  course_id: {
    label: "Course",
    value: "",
    errors: [],
    type: "select",
    rules: {
      require: true,
    },
  },

  period_id: {
    label: "Periods",
    value: "",
    errors: [],
    type: "select",
    rules: {
      require: true,
    },
  },
  search: {
    label: "Buscar",
    value: "",
    errors: [],
    type: "text",
    rules: {
     
    },
  },
};
